/* =============================================================================
   Product Offers - JavaScript
   ============================================================================= */

(function() {
  'use strict';

  function initProductOffers() {
    const popup = document.querySelector('[data-offers-popup]');
    const overlay = document.querySelector('[data-offers-overlay]');
    const openButtons = document.querySelectorAll('[data-offers-open]');
    const closeButtons = document.querySelectorAll('[data-offers-close]');
    const copyButtons = document.querySelectorAll('[data-copy-coupon]');

    if (!popup) {
      return;
    }

    /* Open popup */
    openButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openPopup();
      });
    });

    /* Close popup */
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closePopup();
      });
    });

    /* Close on overlay click */
    if (overlay) {
      overlay.addEventListener('click', function() {
        closePopup();
      });
    }

    /* Close on ESC key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) {
        closePopup();
      }
    });

    /* Copy coupon buttons */
    copyButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        copyCoupon(btn);
      });
    });

    function openPopup() {
      popup.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('offers-popup-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('offers-popup-open');
      document.body.style.overflow = '';
    }

    function copyCoupon(button) {
      var couponCode = button.getAttribute('data-copy-coupon');
      if (!couponCode) return;

      /* Try clipboard API first */
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(couponCode).then(function() {
          showCopiedFeedback(button);
        }).catch(function() {
          fallbackCopy(couponCode, button);
        });
      } else {
        fallbackCopy(couponCode, button);
      }
    }

    function fallbackCopy(text, button) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      textArea.style.top = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        showCopiedFeedback(button);
      } catch (err) {
        console.error('Failed to copy coupon code:', err);
      }

      document.body.removeChild(textArea);
    }

    function showCopiedFeedback(button) {
      var copyIcon = button.querySelector('.product-offers__copy-icon');
      var checkIcon = button.querySelector('.product-offers__check-icon');
      var copyText = button.querySelector('.product-offers__copy-text');

      button.classList.add('is-copied');
      if (copyIcon) copyIcon.style.display = 'none';
      if (checkIcon) checkIcon.style.display = 'block';
      if (copyText) copyText.textContent = 'Copied!';

      setTimeout(function() {
        button.classList.remove('is-copied');
        if (copyIcon) copyIcon.style.display = 'block';
        if (checkIcon) checkIcon.style.display = 'none';
        if (copyText) copyText.textContent = 'Copy';
      }, 2000);
    }
  }

  /* Initialize when DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductOffers);
  } else {
    initProductOffers();
  }

  /* Re-initialize on Shopify section events */
  document.addEventListener('shopify:section:load', initProductOffers);
  document.addEventListener('shopify:section:select', initProductOffers);

})();
